import { render, staticRenderFns } from "./ZouShi.vue?vue&type=template&id=08ac7a40&scoped=true"
import script from "./ZouShi.vue?vue&type=script&lang=js"
export * from "./ZouShi.vue?vue&type=script&lang=js"
import style0 from "./ZouShi.vue?vue&type=style&index=0&id=08ac7a40&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ac7a40",
  null
  
)

export default component.exports